import { type AnalyticsEventPayload } from '@atlaskit/analytics-next';
import { useCallback, useRef } from 'react';

export const useFireEventOnce = () => {
	const hasFired = useRef(false);

	return useCallback((event: AnalyticsEventPayload) => {
		if (hasFired.current) {
			return;
		}

		hasFired.current = true;

		event.fire();
	}, []);
};
